var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-nav-bar",
    {
      staticClass: "header-wrap",
      class: { transparent: _vm.bgTransparent },
      attrs: {
        "left-arrow": _vm.hasArrow,
        "left-text": _vm.leftText,
        "right-text": _vm.rightText,
        title: _vm.headerTitle ? _vm.headerTitle : _vm.title,
      },
      on: {
        touchmove: function ($event) {
          $event.preventDefault()
        },
        "click-left": _vm.onClickLeft,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "title",
            fn: function () {
              return [_vm._t("title")]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [_vm._t("right-icon")]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }